import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';
import logo from '../Assets/logo.png';
import SignInModal from './SignInModal';
import SignUpModal from './SignUpModal';

// import Navbar from './Navbar';  ✅ import Navbar

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [showSignUpModal, setShowSignUpModal] = useState(false);

  // const [isSearchOpen, setIsSearchOpen] = useState(false); // NEW

   // ✅ MOBILE MENU STATE (shared with Navbar)
  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // const toggleDropdown = () => {
  //   setDropdownOpen(!dropdownOpen);
  // };

  // const closeDropdown = () => {
  //   setDropdownOpen(false);
  // };

  // ✅ Hamburger toggle
  // const toggleMenu = () => {
  //   setMobileMenuOpen(prev => !prev);
  // };


  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const closeDropdown = () => {
    setDropdownOpen(false);
  };

  return (
    <header className="header">
      <div className="header-top-bar">
        <div className="container">
          <div className="top-bar-content">
            <button 
              className="dropdown-trigger"
              onClick={toggleDropdown}
              aria-label="Company & Products Menu"
            >
              <span>RedboxGlobal the Company & Its Products</span>
              <span className={`dropdown-arrow ${dropdownOpen ? 'open' : ''}`}>▼</span>
            </button>
            
            
            <span className="breadcrumb-separator">|</span>
            
            <Link to="/terminal-demo" className="top-bar-link">RedboxGlobal Terminal Demo Request</Link>
            
            <span className="breadcrumb-separator">|</span>
            
            <Link to="/remote-login" className="top-bar-link highlight-link">RedboxGlobal Anywhere Remote Login</Link>
            
            <span className="breadcrumb-separator">|</span>
            
            <Link to="/support" className="top-bar-link">RedboxGlobal Customer Support</Link>
            
            {dropdownOpen && (
              <div className="mega-dropdown">
                <button className="dropdown-close" onClick={closeDropdown}>✕</button>
                <div className="dropdown-wrapper">
                  <div className="dropdown-sidebar">
                    <div className="sidebar-section">
                      <h2>RedboxGlobal</h2>
                      <p>Connecting decision makers to a dynamic network of information, people and ideas, Redbox Global quickly and accurately delivers business and financial information, news and insight around the world</p>
                    </div>
                    
                    <div className="sidebar-section">
                      <h3>For Customers</h3>
                      <ul>
                        <li><a href="#remote-login" onClick={closeDropdown}>Redbox Anywhere Remote Login</a></li>
                        <li><a href="#updates" onClick={closeDropdown}>Software Updates</a></li>
                        <li><a href="#account" onClick={closeDropdown}>Manage Products and Account Information</a></li>
                      </ul>
                    </div>
                    
                    <div className="sidebar-section">
                      <h3>Support</h3>
                      <div className="support-contacts">
                        <p><strong>Americas</strong> +1 212 318 2000</p>
                        <p><strong>EMEA</strong> +44 20 7330 7500</p>
                        <p><strong>Asia Pacific</strong> +65 6212 1000</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="dropdown-content">
                    <div className="dropdown-section">
                      <h3>COMPANY</h3>
                      <ul>
                        <li><Link to="/about-us" onClick={closeDropdown}>About</Link></li>
                        <li><Link to="/careers" onClick={closeDropdown}>Careers</Link></li>
                        <li><Link to="/inclusion" onClick={closeDropdown}>Inclusion at Redbox Global</Link></li>
                        <li><Link to="/techatredboxGlobal" onClick={closeDropdown}>Tech at Redbox Global</Link></li>
                        <li><Link to="/philanthropy" onClick={closeDropdown}>Philanthropy</Link></li>
                        <li><Link to="/sustainability" onClick={closeDropdown}>Sustainability</Link></li>
                        <li><Link to="/beta" onClick={closeDropdown}>Redbox Global Beta</Link></li>
                      </ul>
                      
                      <h3 className="section-subtitle">Communications</h3>
                      <ul>
                        <li><Link to="/press-announcements" onClick={closeDropdown}>Press Announcements</Link></li>
                        <li><Link to="/press-contacts" onClick={closeDropdown}>Press Contacts</Link></li>
                      </ul>
                      
                      <h3 className="section-subtitle">Follow</h3>
                      <ul className="social-links">
                        <li>
               <a href="#facebook" onClick={closeDropdown}>
              <span className="social-text">Facebook</span>
             <span className="social-icon">
             <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
           <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
           </svg>
        </span>
       </a>
     </li>
             <li>          
          <a href="#instagram" onClick={closeDropdown}>
          <span className="social-text">Instagram</span>
         <span className="social-icon">
           <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
         </span>
       </a>
      </li>
                       
                        <li>
         <a href="#linkedin" onClick={closeDropdown}>
          <span className="social-text">LinkedIn</span>
          <span className="social-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      </span>
    </a>
  </li>
                    <li>
    <a href="#youtube" onClick={closeDropdown}>
      <span className="social-text">YouTube</span>
      <span className="social-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
        </svg>
      </span>
    </a>
  </li>

  <li>
  <a href="#telegram" onClick={closeDropdown}>
    <span className="social-text">Telegram</span>
    <span className="social-icon">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
        <path d="M9.993 15.674l-.398 5.614c.57 0 .817-.244 1.113-.537l2.67-2.56 5.537 4.05c1.016.56 1.735.266 1.99-.94l3.607-16.91.001-.001c.3-1.39-.502-1.934-1.49-1.57L1.18 9.545c-1.36.53-1.34 1.29-.23 1.63l5.87 1.833 13.62-8.59c.64-.39 1.22-.174.74.215"/>
      </svg>
    </span>
  </a>
</li>
</ul>
                
                    </div>
                    
                    <div className="dropdown-section">
                      <h3>PRODUCTS</h3>
                      <ul>
                        <li><Link to="/professional-services" onClick={closeDropdown}>RedboxGlobal Professional Services</Link></li>
                        <li><Link to="/terminal" onClick={closeDropdown}>RedboxGlobal Terminal</Link></li>
                        <li><Link to="/data" onClick={closeDropdown}>Data</Link></li>
                        <li><Link to="/trading" onClick={closeDropdown}>Trading</Link></li>
                        <li><Link to="/risk" onClick={closeDropdown}>Risk</Link></li>
                        <li><Link to="/compliance" onClick={closeDropdown}>Compliance</Link></li>
                        <li><Link to="/indices" onClick={closeDropdown}>Indices</Link></li>
                      </ul>
                      
                      <h3 className="section-subtitle">Industry Products</h3>
                      <ul>
                        <li><Link to="/law" onClick={closeDropdown}>RedboxGlobal Law</Link></li>
                        <li><Link to="/tax" onClick={closeDropdown}>RedboxGlobal Tax</Link></li>
                        <li><Link to="/government" onClick={closeDropdown}>RedboxGlobal Government</Link></li>
                        <li><Link to="/nef" onClick={closeDropdown}>RedboxGlobal NEF</Link></li>
                      </ul>
                    </div>
                    
                    <div className="dropdown-section">
                      <h3>MEDIA</h3>
                      <ul>
                        <li><Link to ="/markets" onClick={closeDropdown}>RedboxGlobal Markets</Link></li>
                        <li>< Link to="/tech" onClick={closeDropdown}>RedboxGlobal Technology</Link></li>
                        <li>< Link to="/pursuits" onClick={closeDropdown}>RedboxGlobal  Pursuits</Link></li>
                        <li>< Link to="/politics" onClick={closeDropdown}>RedboxGlobal Politics</Link></li>
                        <li>< Link to="/opinion" onClick={closeDropdown}>RedboxGlobal Opinion</Link></li>
                        <li>< Link to ="/businessweek" onClick={closeDropdown}>RedboxGlobal Businessweek</Link></li>
                        <li>< Link to="/live-tv" onClick={closeDropdown}>RedboxGlobal Live Conferences</Link></li>
                        <li>< Link to="/radio" onClick={closeDropdown}>RedboxGlobal Radio</Link></li>
                        <li>< Link to="/redbox-tv" onClick={closeDropdown}>RedboxGlobal Television</Link></li>
                        <li><Link to="/newsletters" onClick={closeDropdown}>News Bureaus</Link></li>
                      </ul>
                      
                      <h3 className="section-subtitle">Media Services</h3>
                      <ul>
                        <li><Link to="/media-studios" onClick={closeDropdown}>Redbox Media Distribution</Link></li>
                        <li><Link to="/advertising" onClick={closeDropdown}>Advertising</Link></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
       
      
      <div className="header-main">
     
        <div className="container">
           <nav className="header-nav">
            <div className="logo">
            <a href="/" aria-label="Redbox Global Home">
                <img src={logo} alt="Redbox Global" className="logo-image" />
              </a>
            </div>

           <div className={`nav-links ${menuOpen ? 'active' : ''}`}>
              {/* nav links reserved for future use */}
            </div>

            {/* Always-visible: Sign In, Subscribe, Hamburger */}
            <div className="header-actions">
               {/* <Link to="/signin" className="signin-link">Sign In</Link> */}

              <span 
                    className="signin-link"
                    onClick={() => setShowModal(true)}
                    style={{ cursor: "pointer" }}
                   >
                    Sign In
               </span>
               {/* <Link to="/subscribe" className="subscribe-btn">Subscribe</Link> */}
               
              
              {/* <button 
          className="mobile-menu-toggle" 
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
          <span className="hamburger-line"></span>
        </button> */}




               <button 
                className={`menu-toggle ${menuOpen ? 'active' : ''}`}
                onClick={toggleMenu}
                aria-label="Toggle navigation menu"
              >
                <span></span>
                <span></span>
                <span></span>
              </button>
            </div> 
            

           </nav>
        
          
         </div> 
      
         </div>

           {/* ✅ NAVBAR (Controlled by Header) */}
      {/* <Navbar 
        isMobileMenuOpen={mobileMenuOpen}
        setIsMobileMenuOpen={setMobileMenuOpen}
      /> */}


          {showModal && <SignInModal show={showModal} onClose={() => setShowModal(false)} />}
        
       {showSignUpModal && <SignUpModal show={showSignUpModal} onClose={() => setShowSignUpModal(false)} />}
        
       </header>
        
        );
};
export default Header;


